import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReminderForm, {
  ReminderFormFields,
} from '../../components/Reminder/ReminderForm';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';

export default function RemindersEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [formFields, setFormFields] = useState<ReminderFormFields>(
    null as unknown as ReminderFormFields
  );
  const [formErrors, setFormErrors] = useState({});

  async function getReminder() {
    if (organization && id) {
      const { data } = await api.get(
        `organizations/${organization.id}/reminders/${id}`
      );

      setFormFields({
        description: data.description,
        isRequired: data.isRequired,
        isActive: data.isActive,
      });
      setIsLoading(false);
    }
  }

  const onSubmit = async (data: ReminderFormFields) => {
    try {
      await api.put(`organizations/${organization.id}/reminders/${id}`, data);

      navigate('/reminders');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  useEffect(() => {
    getReminder();
  }, [organization, id]);

  return (
    <ReminderForm
      isLoading={isLoading}
      title='Editar Lembrete'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
